import request from './request';

function getEvents(data) {
	return request({
		url: '/events',
		method: 'GET',
		params: data,
	});
}

function getEvent(data) {
	const { eventID, ...others } = data;
	return request({
		url: `/events/${eventID}`,
		method: 'GET',
		params: others,
	});
}

function updateEventStatus(data) {
	const { eventID, ...others } = data;
	return request({
		url: `/events/${eventID}/status`,
		method: 'PUT',
		data: others,
	});
}

function createEvent(data) {
	return request({
		url: `/events`,
		method: 'POST',
		data: data,
	});
}

function updateEvent(data) {
	const { eventID, ...others } = data;
	return request({
		url: `/events/${eventID}`,
		method: 'PUT',
		data: others,
	});
}

function deleteEvent(data) {
	const { eventID, ...others } = data;
	return request({
		url: `/events/${eventID}`,
		method: 'DELETE',
		data: others,
	});
}

function checkConflict(data) {
	return request({
		url: `/events/check-conflict`,
		method: 'POST',
		data: data,
	});
}

export default {
	getEvent,
	getEvents,
	updateEventStatus,
	createEvent,
	updateEvent,
	deleteEvent,
	checkConflict
};
